// extracted by mini-css-extract-plugin
module.exports = {"container":"StarCheckbox_container__3cTdO","starCheckmark":"StarCheckbox_starCheckmark__2-9ry"};